import { ProjectTimeframe as TimeframeType } from '__generated__/types';
import { Matrix, MatrixItem } from 'common/components/Matrix';
import ImageTile from 'launch/components/ImageTile';
import Mediabox from 'launch/components/Mediabox';
import * as React from 'react';

export interface Props {
    value: string;
    onChange: (value: TimeframeType) => void;
}

export default class TimeFrame extends React.Component<Props> {
    render() {
        const imagePath = function(fileName: string) {
            return require(`images/projects/create/${fileName}`);
        };

        const options = [
            {
                key: TimeframeType.FORTY_EIGHT_HOURS,
                url: 'calendar_hour.svg',
                title: __('48 hours'),
                label: __('Quick turnaround fees typically apply'),
            },
            {
                key: TimeframeType.ONE_WEEK,
                url: 'calendar_1week.svg',
                title: __('1 week'),
                label: '',
            },
            {
                key: TimeframeType.TWO_WEEKS,
                url: 'calendar_2weeks.svg',
                title: __('2 weeks'),
                label: '',
            },
            {
                key: TimeframeType.ONE_MONTH,
                url: 'calendar_month.svg',
                title: __('1 month'),
                label: '',
            },
            {
                key: TimeframeType.SPECIFIC_DATES,
                url: 'calendar_date.svg',
                title: __('Choose a start & end date'),
                label: '',
            },
            {
                key: TimeframeType.NOT_SURE,
                url: 'calendar_question.svg',
                title: __("Not sure. I'd like to chat with my designer"),
                label: '',
            },
        ];

        const optionItems = options.map(option => (
            <MatrixItem key={option.key}>
                <Mediabox
                    variations={['linked', 'chameleon']}
                    selected={this.props.value == option.key}
                    onClick={() => this.props.onChange(option.key)}
                >
                    <ImageTile
                        imagePadding={true}
                        url={imagePath(option.url)}
                        title={option.title}
                        label={option.label}
                    />
                </Mediabox>
            </MatrixItem>
        ));

        return (
            <Matrix large={3} medium={2} small={1} staggered={false}>
                {optionItems}
            </Matrix>
        );
    }
}
